import React, { useContext } from 'react';
const PartnerPermissions = /*#__PURE__*/React.createContext(undefined);
export function usePartnerPermissions() {
  return useContext(PartnerPermissions);
}
export default PartnerPermissions;